export default {
	"policyDetails.updatePolicy.tooltip":
		"Auch andere Veränderungen können Sie gern melden. Wir prüfen individuell, ob dadurch Anpassungs-Optionen oder -Bedarf entsteht. Meldungen bitte immer innerhalb von 6 Monaten nach dem Eintritt der Änderung melden, wenn Sie die Option ohne neue Gesundheitsprüfung nutzen möchten.",
	"policyDetails.kicker": "Ihre persönliche Versicherung",
} as const;
